import React, { useState, useRef } from "react";
import "../styles/components/header.css";
import BGVideo from "../media/bg_video.mp4";
import icon1 from "../media/home-img1.png";
import icon2 from "../media/Home-img2.png";
import icon3 from "../media/home-img3.png";
import icon4 from "../media/Home-img4.png";
import icon5 from "../media/Home-img5.png";
import icon6 from "../media/Home-img6.png";
import logo from "../media/logo.png";

const Header = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="header-container">
      {/* Background Video */}
      <video
        ref={videoRef}
        className="background-video"
        autoPlay
        loop
        muted={isMuted}
      >
        <source src={BGVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Video Controls */}

        {/* Pause/Play Button */}
        <button className="play-pause-btn" onClick={togglePlay}>
          <i className={isPlaying ? "fa fa-pause" : "fa fa-play"} style={{"color":"#a9a9a9"}}></i>
        </button>

        {/* Mute/Unmute Button */}
        <button className="mute-btn" onClick={toggleMute}>
          <i className={isMuted ? "fa fa-volume-mute" : "fa fa-volume-up"} style={{"color":"#a9a9a9"}}></i>
        </button>
   

      {/* Logo */}
      <div className="logo-container">
        <img src={logo} alt="Website Logo" className="logo" />
      </div>

      {/* Shape Divider */}
      <div className="custom-shape-divider-bottom-1733471161">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="shape-fill"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default Header;
